const rm = {
  namespaced: true,
  state: {
    pemeriksaanNote: null,
    pemeriksaanDraw: false,
    pasienGolonganDarah: null,
  },
  getters: {
    pemeriksaanNote: state => state.pemeriksaanNote,
    pemeriksaanDraw: state => state.pemeriksaanDraw,
    pasienGolonganDarah: state => state.pasienGolonganDarah,
  },
  mutations: {
    SET_PEMERIKSAAN_NOTE(state, value) {
      state.pemeriksaanNote = value;
    },
    SET_PEMERIKSAAN_DRAW(state, value) {
      state.pemeriksaanDraw = value;
    },
    SET_PASIEN_GOL_DARAH(state, value) {
      state.pasienGolonganDarah = value;
    },
    RESET_RM(state) {
      state.pemeriksaanNote = null;
      state.pemeriksaanDraw = false;
      state.pasienGolonganDarah = null;
    },
  }
};
export default rm;